import * as $ from 'jquery';

declare const $zopim: any;
declare var endTime: any;
var dealerInterval;

$(document).ready(() => {

    let zopimLoaded = false;

    const $chatButton = $('.chat-button');
    $chatButton.on('click', () => {
        if (!zopimLoaded) {
            const el = document.createElement('script');
            el.src = '/dist/snapengage.js';
            el.async = false;
            document.body.appendChild(el);

            el.addEventListener('load', () => {
                setTimeout(() => {
                    $zopim.livechat.window.show();
                }, 1000)
            });
        } else {
            $zopim.livechat.window.show();
        }
    });

    $('.bubbleInfo3').each(function () {
        var distance = 0;
        var time = 250;
        var hideDelay = 5000;

        var hideDelayTimer = null;

        var beingShown = false;
        var shown = false;
        var trigger = $('.trigger2', this);
        var info = $('.popup2', this).css('opacity', 0);


        $([trigger.get(0), info.get(0)]).mouseover(function () {
            if (hideDelayTimer) clearTimeout(hideDelayTimer);
            if (beingShown || shown) {
                // don't trigger the animation again
                return;
            } else {
                // reset position of info box
                beingShown = true;

                info.css({
                    top: -5,
                    left: -10,
                    display: 'block'
                }).animate({
                    top: '-=' + distance + 'px',
                    opacity: 1
                }, time, 'swing', function () {
                    beingShown = false;
                    shown = true;
                });
            }

            return false;
        }).mouseout(function () {
            if (hideDelayTimer) clearTimeout(hideDelayTimer);
            hideDelayTimer = setTimeout(function () {
                hideDelayTimer = null;
                info.animate({
                    top: '-=' + distance + 'px',
                    opacity: 0
                }, time, 'swing', function () {
                    shown = false;
                    info.css('display', 'none');
                });

            }, hideDelay);

            return false;
        });
    });

    $('select.statedropdownexamprep').change(function () {
        var selstate = $(this).val();
        if (selstate) {
            window.location.href = "/registerexamprep/?statecode=" + selstate;
        }
    });

    $('select.statedropdown, .select-flag').change(function () {
        var selstate = $(this).val();
        if (selstate) {
            window.location.href = "/state/" + selstate;
        }
    });

    $('#nav-parent-center').addClass("selected");
    $(".tooltips").click(function () {
        $(this).next().slideToggle(800);
    });

    var $dealPanel = $('.special-deal');

    function setDealNumbers() {
        var diff = endTime.getTime() - Date.now();
        if (diff <= 0) {
            $dealPanel.addClass('hidden');
            clearInterval(dealerInterval);
        } else {
            $dealPanel.removeClass('hidden');
            var days = Math.floor(diff / (1000 * 60 * 60 * 24));
            $('.sales-time.number-days').text(days);

            diff -= 1000 * 60 * 60 * 24 * days;
            var hours = Math.floor(diff / (1000 * 60 * 60));
            $('.sales-time.number-hours').text(hours);

            diff -= 1000 * 60 * 60 * hours;
            var minutes = Math.floor(diff / (1000 * 60));
            $('.sales-time.number-minutes').text(minutes);

            diff -= 1000 * 60 * minutes;
            var seconds = Math.floor(diff / (1000));
            $('.sales-time.number-seconds').text(seconds);
        }
    }

    if (typeof endTime != 'undefined') {
        setDealNumbers();

        dealerInterval = setInterval(function () {
            setDealNumbers();
        }, 1000);
    }

});

window.addEventListener('unload', function () {
    clearInterval(dealerInterval);
});